module.exports = __webpack_public_path__ + "img/plus_icon.30882f75.svg";